import React, { useEffect, useState } from 'react'
import styled from './ToggleSwitch.module.css'

const Toggle = ({isOn, toggleSwitch}:any) => {
    return (
        <label className={styled.switch}>
            <input type="checkbox" checked={isOn} onChange={toggleSwitch}/>
            <span className={`${styled.slider} ${styled.round}`} />
        </label>
    )
}

export default Toggle